import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "@moeindal/base-raiko-panel-components";

export class GroupsService {
    constructor() {
        this.httpClient = new HttpClient()
    }


    getGroups(findId, page, size, groupName, groupCode) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${findId}/groups`,
                {
                    page,
                    size,
                    name: groupName,
                    groupCode
                }
            ).then(resolve).catch(reject)
        })
    }

    createNewGroup(fundID, groupCode, groupName, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds/${fundID}/groups`,
                {
                    "code": groupCode,
                    "name": groupName,
                    "enabled": enabled
                },
            ).then(resolve).catch(reject)
        })
    }

    getGroupsDetail(fundID, groupId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/groups/${groupId}`
            ).then(resolve).catch(reject)
        })
    }

    updateGroupInfo(fundID, groupId, groupName, groupCode, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${fundID}/groups/${groupId}`,
                {
                    "code": groupCode,
                    "name": groupName,
                    "enabled": enabled
                },
            ).then(resolve).catch(reject)
        })
    }

    getGroupUsers(fundID, groupId, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/groups/${groupId}/members/selections`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    getGroupReport(id, fundID, type) {

        return new Promise((resolve, reject) => {
            this.httpClient.getFile(
                `funds/${fundID}/groups/${id}/reports/${type}`
            ).then(resolve).catch(reject)
        })

    }

    getGroupReportsByFilters(fundID, page, size, startDate, endDate, groupName, groupCode) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `/funds/${fundID}/groups/real-time-reports`,
                {
                    name: groupName,
                    groupCode,
                    page,
                    size,
                    startDate: convertPersianDateToUniversalDate(startDate),
                    endDate: convertPersianDateToUniversalDate(endDate),
                }
            ).then(resolve).catch(reject)
        })
    }

    getGroupReportSummation(fundID, startDate, endDate, groupName, groupCode) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/groups/real-time-reports/summations`,
                {
                    name: groupName,
                    groupCode,
                    startDate: convertPersianDateToUniversalDate(startDate),
                    endDate: convertPersianDateToUniversalDate(endDate),
                }
            ).then(resolve).catch(reject)
        })
    }

    updateGroupLeader(fundID, groupId, id) {
        return this.httpClient.put(
            `funds/${fundID}/groups/${groupId}/leaders`,
            {
                memberId:id
            }
        )
    }
}